export enum USER_ACTIONS {
    SET_TOKEN_AUTH_DATA = 'USER/SET_TOKEN_AUTH_DATA',
    CLEAR_USER_AUTH_DATA = 'USER/CLEAR_USER_AUTH_DATA',
    SET_USER_ADMIN_PROFILE = 'USER/SET_USER_ADMIN_PROFILE',
    CHECK_IS_AUTHORISED = 'USER/CHECK_IS_AUTHORISED',
}

export interface IUserAction {
    type: USER_ACTIONS,
    payload: any
}

export interface IUserProfile {
    id: number,
    firstName: string,
    lastName: string,
    email: string
}

export interface IUser {
    token: string | null,
    isAuthenticated: boolean,
    userProfile: IUserProfile | null
}